import React from 'react';


function TermsOfDeclaration() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Terms of declaration</h1>

        <div className="space-y-12">
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">1. declaration Agreement</h2>
            <p className="text-gray-800 leading-relaxed">
              By applying for declaration, the applicant agrees to these terms. The applicant affirms that all submitted evidence is true and accurate. The applicant agrees to abide by the Council’s decisions regarding status.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">2. declaration Period</h2>
            <p className="text-gray-800 leading-relaxed">
              Declaration is valid for 12 months from the date of issuance. It is not perpetual. Validity is subject to continuous compliance with AASC standards.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">3. Renewal</h2>
            <p className="text-gray-800 leading-relaxed">
              Operators must apply for renewal 30 days before expiration. Renewal requires re-submission of key evidence artifacts. Renewal requires payment of the annual fee.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">4. Fees</h2>
            <p className="text-gray-800 leading-relaxed">
              The annual fee for Accountability Declaration is $997 USD. The annual fee for Level 1 Declaration is $997 USD. Fees are non-refundable once the review process has initiated. Fees support the administration of the standards body.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">5. Compliance Obligations</h2>
            <p className="text-gray-800 leading-relaxed">
              The declared operator must maintain the controls verified during review. The operator must provide the Council with access to relevant records upon request. The operator must display the declaration mark in accordance with usage policies.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">6. Material Changes</h2>
            <p className="text-gray-800 leading-relaxed">
              Operators must notify the Council of material changes. This includes changes to ownership, legal structure, or core AI delivery platforms. Failure to notify may result in suspension.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">7. Termination</h2>
            <p className="text-gray-800 leading-relaxed">
              The Council may terminate declaration for cause. The operator may terminate by voluntary withdrawal. Upon termination, all references to active declaration must be removed within 7 days.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">8. Liability Disclaimer</h2>
            <p className="text-gray-800 leading-relaxed">
              THE AASC PROVIDES declaration "AS IS" WITHOUT WARRANTY. THE COUNCIL IS NOT LIABLE FOR DAMAGES ARISING FROM THE OPERATOR'S SERVICES. THE OPERATOR INDEMNIFIES THE COUNCIL AGAINST THIRD-PARTY CLAIMS.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}

export default TermsOfDeclaration;